import Button from "@mui/material/Button";
import { useContext } from "react";
import { FormContext, Form } from "components/shared/Form";
import ListSelectField from "components/ui/atoms/formFields/ListSelectField";
import { Stack, Box } from "@mui/material";

const sorts = [
  { label: "Newer added", value: "-created_at" },
  { label: "Older added", value: "created_at" },
  { label: "Newer updated", value: "-updated_at" },
  { label: "Older updated", value: "updated_at" },
  { label: "Step ascending", value: "investment_status" },
  { label: "Step descending", value: "-investment_status" },
];

const prepareInitialValues = (object) => ({
  ordering: object?.ordering || "",
});

const DealSortFormFields = () => {
  const { onSubmit } = useContext(FormContext);

  return (
    <Stack spacing={2}>
      <ListSelectField
        options={sorts.map(({ label, value }) => [value, label])}
        name="ordering"
        label="Order by"
      />
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button variant="contained" onClick={onSubmit}>
          Apply
        </Button>
      </Box>
    </Stack>
  );
};

const DealSortForm = (props) => {
  return (
    <Form prepareInitialValues={prepareInitialValues} {...props}>
      <DealSortFormFields />
    </Form>
  );
};

export default DealSortForm;
